import { apiCall } from "./Interceptor";

const GET_PROFILE_DOCUMENTS = "/view/profile/documents";
const GET_MY_PROFILE_DETAILS = "/view/profile";

const getMyProfileDetails = async (id) => {
    let url = GET_MY_PROFILE_DETAILS;
    if (id) {
        url += `?userId=${id}`;
    }
    const response = await apiCall.get(url);
    return response;
}


const getMyProfileDocuments = async (id) => {
    let url = GET_PROFILE_DOCUMENTS;
    if (id) {
        url += `?userId=${id}`;
    }
    const response = await apiCall.get(url);
    return response;
}

export default {
    getMyProfileDocuments,
    getMyProfileDetails,
};